import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { loadPerformance } from '../../actions/data';
import { getFundUnderlying } from '../../reducers/data';
import DetailsTable from './DetailsTable/DetailsTable';
import Spinner from './Spinner';
import CompText from './Compliance/CompText';
import './App.css';

class App extends PureComponent {

  componentDidMount() {
    this.props.loadPerformance();
  }



  render() {

    const {
      fundUnderlying,
    } = this.props;


    if (fundUnderlying.length > 0) {

      return (
        <div className="app">
          {this.props.isLoading ? <Spinner /> : <DetailsTable /> }
          <CompText/>
        </div>
      )
    }
    else {
      return (null)
    }
  }
}

function mapStateToProps(state) {
  return {
    fundUnderlying: getFundUnderlying,
    isLoading: state.data.isLoading,
  };
}

export default connect(
  mapStateToProps,
  {
    loadPerformance,
    // loadChartData,
    // setChartParam,
    //setPerfStartDate,
    //setPerfEndDate
  },
)(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js